import { useEffect, useState } from 'react';
import { loadCookieSdk } from '../services/cookieConsentService';
import { type CookieConsentResult, NonEssentialVendors } from '../types/cookieConsent';

const defaultConsent: CookieConsentResult = {
  [NonEssentialVendors.Wootric]: false,
  [NonEssentialVendors.FeedbackCollector]: false,
};
const applicationId = 'd1a45014-f485-4817-8c02-5243395572fd';

export function useCookieConsent(policyUrl?: string) {
  const [cookieConsent, setCookieConsent] = useState<CookieConsentResult | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!policyUrl) {
      setCookieConsent(defaultConsent);
      setIsLoading(false);
      return;
    }

    const init = async () => {
      try {
        const consent = await loadCookieSdk(applicationId, policyUrl);
        setCookieConsent(consent ?? defaultConsent);
      } catch (err) {
        console.error('Failed to load cookie consent:', err);
        setCookieConsent(defaultConsent);
      } finally {
        setIsLoading(false);
      }
    };
    init();
  }, [policyUrl]);

  return { cookieConsent, isLoading };
}
